import {
  ThemePerformanceSortHorizon,
  ThemePerformanceSubClass,
} from '@api/api/theme-overview';
import { useV7ThemePerformanceTimeseries } from '@terminal/react-query-hooks/themes/useV7ThemePerformanceTimeseries';

export const useThemePerformanceTimeseries = (
  {
    themeId,
    horizon,
    subClass,
  }: {
    themeId: string;
    horizon: ThemePerformanceSortHorizon;
    subClass?: ThemePerformanceSubClass;
  },
  enabled = true
) => useV7ThemePerformanceTimeseries({ themeId, horizon, subClass }, enabled);
